<!--
  Tier A — fill on screen. `tasks/practice-documents.md` §5.

  THREE ROWS, and the middle one is the only one that scrolls: a header naming the document, the
  viewer, and a sticky action bar. On a phone the bar must never be something you scroll to find,
  which is why it is a sibling of the viewer and not inside it.
-->
<div class="dfd">

  <header class="dfd__bar dfd__bar--top">
    <div class="dfd__title">
      <h2 class="dfd__name">{{ data.documentName }}</h2>
      <p class="dfd__hint" *ngIf="ready" data-testid="dfd-ready">
        Tap a box to type in it. Scroll down for the rest of the pages.
      </p>
      <p class="dfd__hint" *ngIf="!ready" data-testid="dfd-loading">
        Opening your document…
      </p>
    </div>
    <button mat-icon-button type="button" class="dfd__close" (click)="cancel()"
      aria-label="Close without sending" data-testid="dfd-cancel">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <!--
    THE VIEWER.

    `[disableForms]="false"` is the whole feature: AcroForm editing on, so the widgets in the
    practice's own PDF become real inputs. Everything else on this element is either mobile
    ergonomics or a deliberate removal — see the component's header block for why each of the
    disabled toolbar buttons is disabled rather than simply not mentioned.
  -->
  <div class="dfd__viewer">
    <ngx-extended-pdf-viewer *ngIf="data.blankUrl" [src]="data.blankUrl" [useBrowserLocale]="true"
      height="100%" [zoom]="zoom" [mobileFriendlyZoom]="'150%'"
      [disableForms]="false"
      [showToolbar]="true" [showZoomButtons]="true" [showPagingButtons]="true"
      [showDownloadButton]="false" [showPrintButton]="false" [showOpenFileButton]="false"
      [showPresentationModeButton]="false" [showFindButton]="false" [showSidebarButton]="false"
      [showRotateButton]="false" [showSecondaryToolbarButton]="false"
      [showPropertiesButton]="false" [showHandToolButton]="false" [showScrollingButton]="false"
      [showSpreadButton]="false"
      (pdfLoaded)="onPdfLoaded()" (pdfLoadingFailed)="onPdfLoadingFailed()"
      data-testid="dfd-viewer"></ngx-extended-pdf-viewer>
  </div>

  <footer class="dfd__bar dfd__bar--bottom">
    <!--
      The export failed and the dialog is STILL OPEN. Everything the patient typed is on the
      screen behind this message; closing would throw it away with no way back.
    -->
    <p class="dfd__error" *ngIf="exportError" role="alert" data-testid="dfd-export-error">
      {{ exportError }}
    </p>

    <p class="dfd__count" *ngIf="ready && fieldCount" data-testid="dfd-field-count">
      {{ fieldCount }} box{{ fieldCount === 1 ? '' : 'es' }} to fill in.
    </p>

    <!--
      NOT `[disabled]` on a refusal we can explain — but genuinely disabled until the document is
      loaded, because there is nothing to export before then and the failure would be a
      meaningless one (lessons.md §4 is about gates that PROTECT something; this is a button with
      no subject yet).
    -->
    <button mat-flat-button color="primary" type="button" class="dfd__send"
      [disabled]="!ready || isExporting" (click)="send()" data-testid="dfd-send">
      <mat-icon *ngIf="!isExporting">send</mat-icon>
      {{ isExporting ? 'Sending…' : 'Send to the practice' }}
    </button>

    <button mat-button type="button" class="dfd__download" (click)="useDownloadInstead()"
      data-testid="dfd-use-download">
      I would rather download and print it
    </button>
  </footer>

</div>
